import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Store, ShoppingCart, Truck, FileBarChart, Menu } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// ============================================================
// Barra inferior del celular (rediseño, parte 4): Inicio, Ventas (Caja en
// restaurantes), Compras, Reportes y Menú, que abre el menú completo. Solo
// en pantallas chicas; un botón que el usuario no puede abrir no aparece.
// ============================================================

const JERARQUIA = ['consultor', 'operador', 'contador', 'gerente', 'admin'];

export default function BarraInferior({ onAbrirMenu }) {
  const { empresaActivaData, rolActual, esAdminGlobal, modulosActivos } = useAuth();
  const rol = esAdminGlobal ? 'admin' : rolActual || 'consultor';
  const nivel = JERARQUIA.indexOf(rol);
  const tiene = (m) => !!modulosActivos?.[m];
  const operador = nivel >= JERARQUIA.indexOf('operador');
  const contador = nivel >= JERARQUIA.indexOf('contador');

  const tabs = [{ to: '/', label: 'Inicio', icon: Home, end: true }];
  if (empresaActivaData?.rubro === 'restaurante' && operador && tiene('caja')) tabs.push({ to: '/caja', label: 'Caja', icon: Store });
  else if (operador && tiene('ventas')) tabs.push({ to: '/ventas', label: 'Ventas', icon: ShoppingCart });
  if (operador && tiene('proveedores')) tabs.push({ to: '/proveedores', label: 'Compras', icon: Truck });
  else if (contador && tiene('reporte_cxp')) tabs.push({ to: '/reportes/cuentas-por-pagar', label: 'Compras', icon: Truck });
  tabs.push({ to: '/reportes', label: 'Reportes', icon: FileBarChart, end: true });

  const estilo = (activo) =>
    `flex min-h-[48px] flex-col items-center justify-center gap-0.5 text-[11px] font-semibold ${activo ? 'text-turquoise-600' : 'text-slate-500'}`;

  return (
    <nav
      aria-label="Barra inferior"
      className="md:hidden print:hidden fixed inset-x-0 bottom-0 z-20 grid border-t border-slate-200 bg-white px-1 pt-1 pb-[max(0.5rem,env(safe-area-inset-bottom))]"
      style={{ gridTemplateColumns: `repeat(${tabs.length + 1}, minmax(0, 1fr))` }}
    >
      {tabs.map((t) => {
        const Icono = t.icon;
        return (
          <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => estilo(isActive)}>
            <Icono size={22} />
            {t.label}
          </NavLink>
        );
      })}
      <button type="button" onClick={onAbrirMenu} className={estilo(false)}>
        <Menu size={22} />
        Menú
      </button>
    </nav>
  );
}
